import io from "socket.io-client"

const socket = io("https://mcq-ace.onrender.com")

export default socket;